/**
 * Created by maximus on 16.12.16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = wishList;

var _constants = require('redux/constants');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

var _Basket = require('../../components/Basket/Basket');

var _Basket2 = _interopRequireDefault(_Basket);

var _wish_list = require('redux/actions/wish_list');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  wishProducts: []
};

function wishList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


  switch (action.type) {

    case _constants.WishConstants.ADD_TO_WISHLIST:
      var items = [].concat((0, _toConsumableArray3.default)(state.wishProducts)),
          flagPush = true;
      // action.product.modifier_option_id_copy=action.product.modifier_option_id;
      if (action.product) {
        if (items === undefined || items == null || items == '') {
          items = [];
        }
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === action.product.id && items[i].modifier_option_id === action.product.modifier_option_id) {
            flagPush = false;
            break;
          }
        }

        flagPush && items.push((0, _assign2.default)({}, action.product));
      }

      _LocalStorageProxy2.default.setItem('wishlist.common', (0, _stringify2.default)(items));
      // setWishList(JSON.stringify(items));

      return (0, _extends3.default)({}, state, {
        wishProducts: items
      });

    case _constants.WishConstants.DEL_FROM_WISHLIST:
      var arrItems = [].concat((0, _toConsumableArray3.default)(state.wishProducts));
      for (var _i = 0; _i < arrItems.length; _i++) {
        if (arrItems[_i].id === action.product.id && arrItems[_i].modifier_option_id === action.product.modifier_option_id) {
          arrItems.splice(_i, 1);
          break;
        }
      }

      _LocalStorageProxy2.default.setItem('wishlist.common', (0, _stringify2.default)(arrItems));

      return (0, _extends3.default)({}, state, {
        wishProducts: arrItems
      });

    case _constants.WishConstants.COPY_TO_WISHLIST:

      var _wishList = void 0;

      try {
        _wishList = JSON.parse(_LocalStorageProxy2.default.getItem('wishlist.common'));
      } catch (e) {
        _wishList = null;
      }

      if (!Array.isArray(_wishList)) {
        _wishList = [];
      }

      return (0, _extends3.default)({}, state, {
        wishProducts: _wishList
      });

    case _constants.WishConstants.UPDATE_PRODUCT_FOR_WISHLIST:
      var itemsUpdate = [].concat((0, _toConsumableArray3.default)(state.wishProducts));
      return (0, _extends3.default)({}, state, {
        wishProducts: itemsUpdate
      });

    case _constants.WishConstants.GET_ACTUAL_PRICES_LOAD_WISHLIST:
      return (0, _extends3.default)({}, state, {
        preload: true
      });

    case _constants.WishConstants.GET_ACTUAL_PRICES_SUCCESS_WISHLIST:
      _LocalStorageProxy2.default.setItem('wishlist.common', (0, _stringify2.default)(action.result));
      return (0, _extends3.default)({}, state, {
        preload: false,
        serverLoad: true,
        wishProducts: action.result
      });

    case _constants.WishConstants.GET_ACTUAL_PRICES_FAIL_WISHLIST:
      return (0, _extends3.default)({}, state, {
        preload: false
      });

    case _constants.AuthConstants.LOGIN_SUCCESS:
      var wishListUpdate = JSON.parse(_LocalStorageProxy2.default.getItem('wishlist.common'));
      return (0, _extends3.default)({}, state, {
        wishProducts: wishListUpdate
      });
    //
    // case WishConstants.SET_WISHLIST:
    //     return {
    //         ...state,
    //         preload: false
    //     };
    //
    // case WishConstants.SET_WISHLIST_SUCCESS:
    //     return {
    //         ...state,
    //         preload: false
    //     };

    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/wish_list.js
// module id = 1918
// module chunks = 0